"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SvgRenderingContext = void 0;
var RenderingContext_1 = require("./RenderingContext");
var SvgRenderingContext = /** @class */ (function (_super) {
    __extends(SvgRenderingContext, _super);
    function SvgRenderingContext(svgElement) {
        var _this = _super.call(this, svgElement) || this;
        _this._saveStack = [];
        _this._lastChangedElement = svgElement;
        return _this;
    }
    Object.defineProperty(SvgRenderingContext.prototype, "globalAlpha", {
        get: function () {
            throw new Error("Method not implemented.");
        },
        set: function (alpha) {
            var _a;
            var lastStyle = (_a = this._lastChangedElement.getAttribute("style")) !== null && _a !== void 0 ? _a : "";
            this._lastChangedElement.setAttribute("style", lastStyle + ("opacity: " + alpha));
        },
        enumerable: false,
        configurable: true
    });
    SvgRenderingContext.prototype.save = function () {
        this._saveStack.push(this._lastChangedElement);
    };
    SvgRenderingContext.prototype.restore = function () {
        var lastIndex = this._saveStack.length - 1;
        this._lastChangedElement = this._saveStack[lastIndex];
        this._saveStack.splice(lastIndex, 1);
    };
    SvgRenderingContext.prototype.translate = function (x, y) {
        var group = this._createGroupElement();
        group.setAttribute("transform", "translate(" + x + ", " + y + ")");
        this._insertIntoTreeAndMakeLastChanged(group);
    };
    SvgRenderingContext.prototype.rotate = function (angle) {
        var group = this._createGroupElement();
        var radians = angle * (180 / Math.PI);
        group.setAttribute("transform", "rotate(" + radians + ")");
        this._insertIntoTreeAndMakeLastChanged(group);
    };
    SvgRenderingContext.prototype.scale = function (x, y) {
        var group = this._createGroupElement();
        group.setAttribute("transform", "scale(" + x + " " + y + ")");
        this._insertIntoTreeAndMakeLastChanged(group);
    };
    SvgRenderingContext.prototype.drawSubcanvas = function (subcanvas, x, y, object) {
        // @ts-ignore
        var svgContent = subcanvas.toBuffer().toString()
            .replace("<?xml version=\"1.0\" encoding=\"UTF-8\"?>", "")
            .replace(/"([0-9]+)pt"/g, "$1px");
        this.unsafeInsertSvg(svgContent);
    };
    SvgRenderingContext.prototype._createGroupElement = function () {
        return document.createElementNS("http://www.w3.org/2000/svg", "g");
    };
    SvgRenderingContext.prototype._insertIntoTreeAndMakeLastChanged = function (groupElement) {
        this._lastChangedElement.append(groupElement);
        this._lastChangedElement = groupElement;
    };
    /**
     * The given SVG string is expected to be trusted or strictly sanitized. We don't
     * sanitize again here for performance reasons (JSDom operations can easily
     * take 10+ seconds when base64 embedded images are involved).
     */
    SvgRenderingContext.prototype.unsafeInsertSvg = function (svgString) {
        this._lastChangedElement.innerHTML = svgString;
    };
    SvgRenderingContext.prototype.getImageData = function (x, y, width, height) {
        throw new Error("Method not implemented.");
    };
    SvgRenderingContext.prototype.setLineDash = function (segments) {
        throw new Error("Method not implemented.");
    };
    SvgRenderingContext.prototype.strokeRect = function (x, y, width, height) {
        throw new Error("Method not implemented.");
    };
    SvgRenderingContext.prototype.clearRect = function (x, y, width, height) {
        throw new Error("Method not implemented.");
    };
    SvgRenderingContext.prototype.fillRect = function (x, y, width, height) {
        throw new Error("Method not implemented.");
    };
    return SvgRenderingContext;
}(RenderingContext_1.RenderingContext));
exports.SvgRenderingContext = SvgRenderingContext;
//# sourceMappingURL=SvgRenderingContext.js.map